export default "jQuery(document).ready(function(){$(\"#litkey\").change(function(){var n=reprintUrl+\"/\"+$(this).val();window.location.href=n})});";